export default "__VITE_PUBLIC_ASSET__9b216fe6__"